import { IntlShape } from "react-intl";
import SweetAlert from "sweetalert2";
import { APP_COLORS } from "../../witadmin/Common/constants";
import globalMessages from "../../witadmin/intl/globalMessages";

const messages: Record<string, Record<string, String>> = {
  minLength: {
    en: "{{#def.n}}should not be shorter than {{=n}} character{{#def.mPlural}}",
    es: "{{#def.n}}no debe contener menos de {{=n}} caracter{{? n!=1 }}es{{?}}",
  },
  ok: {
    id: "default.ok",
    defaultMessage: "OK",
  },
};

export async function showErrorAlert({
  title,
  text,
  intl,
}: {
  title: string;
  text: string;
  intl: IntlShape;
}) {
  return SweetAlert.fire({
    title,
    text,
    icon: "error",
    confirmButtonText: intl.formatMessage(globalMessages.ok),
    confirmButtonColor: APP_COLORS.green,
  });
}

export default messages;
